import React from 'react';
import { CustomModalLayout, Modal, Text } from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';
export function UpdateModal({ app, msId, closeModal, openCompleteUpdateInEditor, }) {
    const t = useTranslation();
    const appId = app?.appId || '';
    const appName = app?.appInfo?.name?.replace('&amp;', '&');
    const trnaslatedTitle = t('manage-apps.update-from-editor-modal-title', { name: appName });
    const title = trnaslatedTitle.replace('&amp;', '&').replace('&#x2F;', '/');
    const onGoToEditorClick = () => {
        openCompleteUpdateInEditor(appId);
        closeModal();
    };
    const onCloseClick = () => {
        closeModal();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(CustomModalLayout, { width: "510px", title: title, dataHook: "update-editor-app-from-bm-modal", primaryButtonText: t('manage-apps.update-from-editor-modal-primary-button'), primaryButtonOnClick: onGoToEditorClick, secondaryButtonText: t('manage-apps.update-from-editor-modal-secondary-button'), secondaryButtonOnClick: onCloseClick, onCloseButtonClick: onCloseClick },
            React.createElement(Text, null, t('manage-apps.update-from-editor-modal-content')))));
}
//# sourceMappingURL=update-modal.js.map